export interface IUserIdentityConfirmationStatus {
  confirmed: boolean;
  requested?: boolean;
}
